import { render } from "./SearchBox.vue?vue&type=template&id=437905a4"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=437905a4&lang=scss"

import exportComponent from "C:\\Programming\\VUE\\zoopay\\zoopay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__